import { Button, Form, Image } from "react-bootstrap";
import toast from "react-hot-toast";
import secureLocalStorage from "react-secure-storage";
import { loginAuth } from "./fetch";
import { useState } from "react";
import { Eye, EyeOff, Lock, User } from "react-feather";

const Login = () => {
  const [usernameVal, setUsernameVal] = useState();
  const [passwordVal, setPasswordVal] = useState();

  const [passwordShow, setPasswordShow] = useState(true);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      if (usernameVal === "" || passwordVal === "") {
        return toast.error("Masukkan Username Atau Password");
      }

      const params = {
        username: usernameVal,
        password: passwordVal,
      };

      const res = await loginAuth(params);

      if (res.status) {
        secureLocalStorage.setItem("tokenPartner", res?.data);
        if (usernameVal) {
          secureLocalStorage.setItem("partnerName", usernameVal);
        }
        setTimeout(() => {
          setTimeout(() => {
            window.location.href = "/";
          }, 1000);

          toast.success("Berhasil Login");
        }, 1000);
      } else {
        toast.error("Gagal Login, Periksa Data Kamu");
      }
    } catch (error) {}
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <Image
          src={require("../../assets/header.png")}
          className="login-logo"
          alt="Pocketsid Partner"
        />
        <h5 className="login-title">Selamat Datang 👋</h5>
        <p className="login-subtitle">Masuk sebagai Partner Pocketsid</p>

        <Form onSubmit={handleLogin}>
          <Form.Label className="login-label">Username</Form.Label>
          <div className="login-input-group">
            <User size={18} className="login-icon" />
            <Form.Control
              placeholder="Masukkan Username"
              onChange={(e) => setUsernameVal(e.target.value)}
              required
            />
          </div>

          <Form.Label className="login-label">Kata Sandi</Form.Label>
          <div className="login-input-group">
            <Lock size={18} className="login-icon" />
            <Form.Control
              placeholder="Masukkan Kata Sandi"
              onChange={(e) => setPasswordVal(e.target.value)}
              required
              type={passwordShow ? "password" : "text"}
            />
            <span
              className="login-eye"
              onClick={() => setPasswordShow(!passwordShow)}
            >
              {passwordShow ? <Eye size={18} /> : <EyeOff size={18} />}
            </span>
          </div>

          <Button type="submit" as="button" className="login-btn mt-2">
            Login
          </Button>
        </Form>

        <p className="login-footer">version 0.0.1</p>
      </div>
    </div>
  );
};

export default Login;
